
const digest = 'c287c0c3c956182ced6f5dca0d1c72fc176e10c46fc5c2c84848032fdb2a6e51';
const classes = {"wrapper":"_wrapper_1u0h2_1","date":"_date_1u0h2_13","title":"_title_1u0h2_19"};
const css = `._wrapper_1u0h2_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 18px 19px;
  gap: 28px;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_1u0h2_1:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_1u0h2_1 ._date_1u0h2_13 {
  font-size: 14px;
  color: #000000;
  min-width: 120px;
  max-width: 120px;
}
._wrapper_1u0h2_1 ._title_1u0h2_19 {
  color: #000000;
  font-weight: 500;
  flex-grow: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  